export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.discharge-report.index`,
        path: `/${prefix}/${pre}/discharge-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.discharge-report.index`,
                PageDescription: "Patient Reports: Discharge report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.discharge-report.index`,
        path: `/${prefix}/${pre}/discharge-report/print`,
        component: () => import('./prints/DischargeReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.discharge-report.index`,
                PageDescription: "Patient Reports: Discharge report",
            },
            print: true,
        },
    },
];
